// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"867":"b8c53be3","1378":"0ec3c5b2","2717":"c2ed55a1","5576":"9143a8ad","5770":"a8e04ecd","6185":"393c73bc","6264":"33f50ac7","8515":"4e0f7e65"}[chunkId] + ".chunk.css";
};